module.exports = "<i class=\"fa fa-{{template.Icon}} icon\"></i>\r\n<ng-container>\r\n  {{template.UiElementType ? UiElementType[template.UiElementType]: template.Name}}\r\n</ng-container>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/node-type/node-type.component.html
// module id = ../../../../../src/app/node-type/node-type.component.html
// module chunks = 1